// Inline SVGs for client-side templates, same artwork and classes as IconHelper#tc_icon.
// Add a name here and to `USED_ICONS` in lib/tasks/icons.rake (brands live in app/assets/svg/icons/brands).
import classNames from "classnames"
import bold from "tc-icons/lucide/outline/bold.svg?raw"
import calendar from "tc-icons/lucide/outline/calendar.svg?raw"
import check from "tc-icons/lucide/outline/check.svg?raw"
import chevronDown from "tc-icons/lucide/outline/chevron-down.svg?raw"
import chevronLeft from "tc-icons/lucide/outline/chevron-left.svg?raw"
import chevronRight from "tc-icons/lucide/outline/chevron-right.svg?raw"
import chevronUp from "tc-icons/lucide/outline/chevron-up.svg?raw"
import circleQuestionMark from "tc-icons/lucide/outline/circle-question-mark.svg?raw"
import clipboardType from "tc-icons/lucide/outline/clipboard-type.svg?raw"
import clock from "tc-icons/lucide/outline/clock.svg?raw"
import eye from "tc-icons/lucide/outline/eye.svg?raw"
import heading from "tc-icons/lucide/outline/heading.svg?raw"
import italic from "tc-icons/lucide/outline/italic.svg?raw"
import keyboard from "tc-icons/lucide/outline/keyboard.svg?raw"
import link from "tc-icons/lucide/outline/link.svg?raw"
import mail from "tc-icons/lucide/outline/mail.svg?raw"
import maximize2 from "tc-icons/lucide/outline/maximize-2.svg?raw"
import menu from "tc-icons/lucide/outline/menu.svg?raw"
import minimize2 from "tc-icons/lucide/outline/minimize-2.svg?raw"
import phone from "tc-icons/lucide/outline/phone.svg?raw"
import plus from "tc-icons/lucide/outline/plus.svg?raw"
import search from "tc-icons/lucide/outline/search.svg?raw"
import settings from "tc-icons/lucide/outline/settings.svg?raw"
import smartphone from "tc-icons/lucide/outline/smartphone.svg?raw"
import squarePen from "tc-icons/lucide/outline/square-pen.svg?raw"
import star from "tc-icons/lucide/outline/star.svg?raw"
import trash2 from "tc-icons/lucide/outline/trash-2.svg?raw"
import x from "tc-icons/lucide/outline/x.svg?raw"

const ICON_CLASSES = "inline-block size-[1.231em] shrink-0 align-middle relative -top-[0.1em]"

const SVGS = {
  bold,
  calendar,
  check,
  "chevron-down": chevronDown,
  "chevron-left": chevronLeft,
  "chevron-right": chevronRight,
  "chevron-up": chevronUp,
  "circle-question-mark": circleQuestionMark,
  "clipboard-type": clipboardType,
  clock,
  eye,
  heading,
  italic,
  keyboard,
  link,
  mail,
  "maximize-2": maximize2,
  menu,
  "minimize-2": minimize2,
  phone,
  plus,
  search,
  settings,
  smartphone,
  "square-pen": squarePen,
  star,
  "trash-2": trash2,
  x,
}

/**
 * @param {string} name key of SVGS
 * @param {string} [className] appended to the default icon classes
 * @returns {string} svg markup
 */
export default function icon(name, className) {
  const svg = SVGS[name]
  if (!svg) throw new Error(`Unknown icon: ${name}`)
  const classes = classNames(ICON_CLASSES, className)
  return svg
    .trim()
    .replace(/<svg[^>]*>/, (tag) =>
      tag
        .replace(/\s(width|height)="\d+"/g, "")
        .replace("<svg", `<svg class="${classes}" data-icon="${name}" aria-hidden="true"`),
    )
}
